import DataLayer from 'utils/DataLayer';
import Settings from 'utils/Settings';

const GladlyController = class {
  static sendGladlyIdsToDataLayer = () => {
    DataLayer.pushEvent({ gladlyAppID: Settings.gladlyAppId });
    DataLayer.pushEvent({ gladlyBrandID: Settings.gladlyBrandId });
  };

  static init = () => {
    GladlyController.sendGladlyIdsToDataLayer();
  };
};

export default GladlyController;
